import { Injectable, inject } from '@angular/core';
import {CertificateProofData} from './certificate-proof-data.model';
import {TenantsDBService} from '../services/tenants-db.service';
import {SchoolUsersDbService} from '../services/school-users-db.service';
import {CoursesDBService} from '../services/courses-db.service';


@Injectable({
  providedIn: 'root'
})
export class CertificateProofService {
  private tenantDB = inject(TenantsDBService);
  private userDB = inject(SchoolUsersDbService);
  private coursesDB = inject(CoursesDBService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);



  constructor() {

  }

  async loadCertificateProofData(tenantId: string, courseId: string, userId: string): Promise<CertificateProofData> {

    const data: CertificateProofData = {
      tenant: null,
      course: null,
      user: null
    }

    try {

      if (tenantId) {
        data.tenant = await this.tenantDB.findTenantById(tenantId).toPromise();
      }

      if (userId) {
         data.user = await this.userDB.findUserByTenantAndId(tenantId, userId).toPromise();
      }

      if (courseId) {
        data.course = await this.coursesDB.findCourseByTenantAndId(tenantId, courseId).toPromise();
      }

    }
    catch (e) {
      console.log(`Error loading certificate proof data: tenantId=${tenantId} userId=${userId} courseId=${courseId}`, e);
    }
    finally {
      return data;
    }

  }

}
